module.exports = __webpack_public_path__ + "img/nwtu.2dfc4673.gif";